"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.minutesFromMidnight = exports.leftpad = exports.lazy = exports.setIsEqual = exports.setUnion = exports.setIntersection = exports.formatDateTime = exports.mapEnum = exports.BuildClass = exports.GetDataSubset = exports.generateHash = exports.guid = exports.timer = exports.bround = exports.clamp = exports.fmtCurrency = exports.prettyJSON = exports.assert = exports.Sleep = exports.Do = void 0;
const pick_1 = __importDefault(require("lodash/pick"));
const tailwind_merge_1 = require("tailwind-merge");
const dates_1 = require("./dates");
const Do = (fn) => fn();
exports.Do = Do;
const Sleep = async (milliseconds) => new Promise(resolve => {
    setTimeout(resolve, milliseconds);
});
exports.Sleep = Sleep;
const assert = (cond, msg) => {
    if (!cond) {
        throw new Error(msg ?? 'Failed assertion');
    }
};
exports.assert = assert;
const prettyJSON = (data) => JSON.stringify(data, null, 2);
exports.prettyJSON = prettyJSON;
const fmtCurrency = (amount) => formatter.format(amount);
exports.fmtCurrency = fmtCurrency;
const formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
const clamp = (val, min, max) => {
    if (min != null && val < min) {
        return min;
    }
    else if (max != null && val > max) {
        return max;
    }
    return val;
};
exports.clamp = clamp;
const bround = (num, decimalPlaces) => {
    const d = decimalPlaces ?? 0;
    const m = 10 ** d;
    const n = +(d ? num * m : num).toFixed(8);
    const i = Math.floor(n);
    const f = n - i;
    const e = 1e-8;
    const r = (0, exports.Do)(() => {
        if (f > 0.5 - e && f < 0.5 + e) {
            return i % 2 === 0 ? i : i + 1;
        }
        return Math.round(n);
    });
    return d ? r / m : r;
};
exports.bround = bround;
const timer = (timeOrHandler, handler) => {
    const isNumber = typeof timeOrHandler == 'number';
    if (handler && isNumber) {
        return window.setTimeout(handler, timeOrHandler);
    }
    if (!isNumber) {
        return window.setTimeout(timeOrHandler);
    }
    return -1;
};
exports.timer = timer;
exports.guid = (0, exports.Do)(() => {
    const s4 = (seedRaw) => {
        const seed = seedRaw % 1;
        const input = (1 + seed) * 0x10000;
        return Math.floor(input).toString(16).substring(1);
    };
    return (seedInput) => {
        const seed = seedInput ?? Math.random();
        const s = (x) => `${s4(0.125 * x + seed)}`;
        return `${s(0)}${s(1)}-${s(2)}-${s(3)}-${s(4)}-${s(5)}${s(6)}${s(7)}`;
    };
});
const generateHash = (string) => {
    let hash = 0;
    if (string.length === 0) {
        return hash;
    }
    string.split('').forEach(chr => {
        const chrNumber = chr.charCodeAt(0);
        hash = ((hash << 5) - hash + chrNumber) | 0;
    });
    return hash;
};
exports.generateHash = generateHash;
const GetDataSubset = (data, keys) => (0, pick_1.default)(data, keys);
exports.GetDataSubset = GetDataSubset;
const BuildClass = (classToBool) => {
    if (classToBool == null) {
        return '';
    }
    if (typeof classToBool === 'string') {
        return (0, tailwind_merge_1.twMerge)(classToBool);
    }
    if (Array.isArray(classToBool)) {
        return (0, tailwind_merge_1.twMerge)(classToBool.filter(Boolean));
    }
    const finalClass = [];
    for (const [cl, apply] of Object.entries(classToBool)) {
        if (apply && cl && cl !== 'null' && cl !== 'undefined') {
            finalClass.push(cl);
        }
    }
    return (0, tailwind_merge_1.twMerge)(finalClass);
};
exports.BuildClass = BuildClass;
const mapEnum = (key, fns) => fns[key]();
exports.mapEnum = mapEnum;
const formatDateTime = (date, fmt) => {
    if (date == null) {
        return '';
    }
    if (typeof date === 'string') {
        if (fmt != null) {
            const dt = dates_1.DateTimeObj.parse(date);
            if (!dt.lx.isValid) {
                return dates_1.DateObj.parse(date).fmt(fmt);
            }
            return dt.fmt(fmt);
        }
        return date;
    }
    return date.fmt(fmt);
};
exports.formatDateTime = formatDateTime;
const setIntersection = (a, b) => {
    if (Object.prototype.hasOwnProperty.call(Set.prototype, 'intersection')) {
        return a.intersection(b);
    }
    if (a.size > b.size) {
        return (0, exports.setIntersection)(b, a);
    }
    const a_copy = new Set(a);
    for (const x of a_copy) {
        if (!b.has(x)) {
            a_copy.delete(x);
        }
    }
    return a_copy;
};
exports.setIntersection = setIntersection;
const setUnion = (a, b) => {
    if (Object.prototype.hasOwnProperty.call(Set.prototype, 'union')) {
        return a.union(b);
    }
    if (a.size > b.size) {
        return (0, exports.setIntersection)(b, a);
    }
    const a_copy = new Set(a);
    for (const x of b) {
        a_copy.add(x);
    }
    return a_copy;
};
exports.setUnion = setUnion;
const setIsEqual = (a, b) => {
    if (a.size !== b.size) {
        return false;
    }
    for (const x of a) {
        if (!b.has(x)) {
            return false;
        }
    }
    return true;
};
exports.setIsEqual = setIsEqual;
const lazy = (f) => {
    let cached = undefined;
    return () => {
        if (cached == undefined) {
            cached = f();
        }
        return cached;
    };
};
exports.lazy = lazy;
const leftpad = (text, len, padChar = '0') => {
    const str = String(text);
    const paddingNeeded = len - str.length;
    return paddingNeeded > 0 ? padChar.repeat(paddingNeeded) + str : str;
};
exports.leftpad = leftpad;
const minutesFromMidnight = (t) => {
    const timeString = t instanceof dates_1.DateTimeObj ? t.time() : t;
    const [h, m] = timeString.split(':').map(Number);
    if (h == null || m == null) {
        throw new Error(`Invalid time values: ${JSON.stringify(t)}`);
    }
    return h * 60 + m;
};
exports.minutesFromMidnight = minutesFromMidnight;
//# sourceMappingURL=util.js.map